import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './pages/Routes';
import Header from './components/header/Header';
import { AuthProvider } from './auth/authProvider/AuthProvider';
import { IntlProvider } from 'react-intl';
import messages from './locale/messages.json';
import { MessageProvider } from './locale/MessageProvider';
import { addTrackingScript, getTealiumState, isTrackingScriptInDom } from './tracking/tracking';

const baseName = process.env.PUBLIC_URL || '/';

const Root: React.FC = () => {
  useEffect(() => {
    if (!isTrackingScriptInDom()) {
      addTrackingScript();
    }
    getTealiumState(200);
  }, []);
  return (
    <AuthProvider>
      <IntlProvider messages={messages} locale="de" defaultLocale="de">
        <MessageProvider>
          <BrowserRouter basename={baseName}>
            <Header />
            <Routes />
          </BrowserRouter>
        </MessageProvider>
      </IntlProvider>
    </AuthProvider>
  );
};

export default Root;
